// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3up1X","colBig":"styles_colBig__17hSZ","colSmall":"styles_colSmall__2J7oR","shopifyNameWrapper":"styles_shopifyNameWrapper__3zYFi"};